<template>
  <div class="wrap">
    <div class="form_wrap_bar">
      <div class="logo">
        <img :src="require('@/assets/ico/A6107.png')" class="logo_img" alt="" />
        <span>{{ verConfig.title }}</span>
      </div>
      <div class="close" @click="toIndex">
        <van-icon name="cross" color="#0f172a" size="16" />
      </div>
      <div class="tab">
        <div class="tab_item" :class="index == tabNum ? 'active_item' : ''" v-for="item, index in tab" :key="index"
          @click="tabNum = index">
          {{ $t(item) }}
        </div>
      </div>
      <LoginForm :formList="formData" cancelText="Login.registrasi" confirmText="newAdd.Login" readText="记住"
        :getRemember="true" :tab-num="tabNum" @cancel="toRegiste" @submit="onSubmit">
      </LoginForm>
      <div class="btns">
        <div class="btns_item" @click="getHome">{{ $t('联系客服') }}</div>
        <div class="btns_item" @click="toIndex">{{ $t('免费试玩') }}</div>
        <div class="btns_item" @click="getHome">{{ $t('忘记密码') }}</div>
        <div class="btns_item" @click="showLang">{{ $t('选择语言') }} {{ lanText }}</div>
      </div>
    </div>

    <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Icon, Image as VImg, Toast, ActionSheet } from "vant";
import LoginForm from "./components/form.vue";
import Cookies from "js-cookie";
import { SEND_SMS_CODE, LOGIN, HOME_IMG } from "@/api";
import { getNewPhone } from "@/utils/tools";
import ServiceBtn from "@/components/serviceBtn";
import verConfig from "@/utils/verConfig";
import { $post } from "../../utils/request";
import { Lans, getLanguage } from "@/i18n";
export default {
  components: {
    [Icon.name]: Icon,
    VImg,
    [ActionSheet.name]: ActionSheet,
    LoginForm,
    ServiceBtn,
    Navbar,
  },
  data() {
    this.Lans = Lans;
    return {
      langicon: "",
      langtext: "",
      show2: false,
      formList: [
        //   {
        //   key: "email",
        //   flag: true,
        //   // icon: "icon-yonghuming",
        //   placeholder: "Login.emailInput",
        //   rules: [{ required: true, message: this.$t("Login.emailInput") }],
        //   img: require('../../assets/login/email.png'),
        // },
        {
          key: "userphone",
          flag: true,
          // icon: "icon-yonghuming",
          label: 'page.Account',
          placeholder: "page.Account",
          rules: [{ required: true, message: this.$t("请输入账号") }],
          // needTrue: true
        },
        {
          placeholder: "page.Password",
          type: "password",
          key: "userpass",
          label: 'page.Password',
          // icon: "icon-zhanghumima",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.passwordEnter") }],
          isPassword: true,
          img: require('../../assets/login/password.png'),
        },
        {
          label: "Login.Daftar.referrer",
          placeholder: "Login.Daftar.referrer",
          type: "text",
          // icon: "icon-yaoqing2",
          img: require('../../assets/login/referrer.png'),
          key: "fromid",
          flag: true,
          rules: [{ required: false, message: this.$t("hint.formidEnter") }],
        },
      ],
      tab: ['newAdd.Login', 'Login.Daftar.title'],
      tabNum: 0
    };
  },
  computed: {
    formData() {
      // if (this.tabNum == 0) {
      //   return this.formList.filter(item => item.key != 'email');
      // }
      // return this.formList.filter(item => item.key != 'userphone');
      if (this.tabNum == 0) {
        return this.formList.filter(item => item.key != 'fromid');
      }
      return this.formList
    },
    lanText() {
      let _obj = Lans.find(item => item.value == getLanguage());
      return _obj?.name || '';
    }
  },
  created() {
    const { id: fromid } = this.$route.query;
    if(fromid){
      this.tabNum = 1;
    }
  },
  methods: {
    async getHome(num = 0) {
      this.$store.dispatch('toService');
      // window.ssq.push('chatOpen');
      return;
      Toast.loading()
      try {
        const { data } = await HOME_IMG();
        Toast.clear()
        if (data) {
          if (data[num]) return window.location.href = data[num].paramet.url;
          const find = data.find(item => item.paramet.url);
          window.location.href = find.paramet.url;
        }
      } catch (error) {
        Toast.clear();
      }
    },
    onSubmit(values, read) {
      Toast.loading({ duration: 0 });
      LOGIN({ ...values }) // http请求
        .then((r) => {
          if (r.data.ret === 1) {
            this.$cookie.set("userInfo", JSON.stringify(r.data.data));
            this.$cookie.set("token", r.data.data.token);
            // this.$cookie.set("the-pwd-state", this.checked);
            if (read) {
              if (this.tabNum == 0) {
                this.$cookie.set(
                  "the-pwd-obj",
                  JSON.stringify({
                    userphone: values.userphone,
                    userpass: values.userpass,
                  })
                );
              } else {
                this.$cookie.set(
                  "the-email-obj",
                  JSON.stringify({
                    email: values.email,
                    userpass: values.userpass,
                  })
                );
              }
            } else {
              this.$cookie.remove("the-pwd-obj");
            }
          } else {
            Toast.clear();
            Toast(r.data.msg);
          }
          return r.data.ret;
        })
        .then(async (ret) => {
          if (ret == 1) {
            this.$store.dispatch("getSystemConfig");
            try {
              const res = await $post("/users/info");
              const { ret, msg, data } = res.data;
              if (ret == 1) {
                // this.LoadingShow = false;
                Toast.clear();
                this.$router.replace({ name: "goods" });
                this.$cookie.set("userInfo", JSON.stringify(data));
              }
            } catch (error) {
              console.error("登录错误", error);
              Toast.clear();
            }
          }
        })
        .catch((e) => {
          Toast.clear();
          console.log(e);
        });
    },
    toRegiste() {
      this.$router.push("/registrasi");
    },
    toIndex() {
      this.$router.push("/goods");
    },
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: var(--bg);
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-image: url("../../assets/login/bg.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);

  /deep/ .van-nav-bar__left {
    .van-icon-arrow-left {
      color: var(--theme) !important;
    }
  }

  /deep/ .van-nav-bar--fixed {
    left: 50% !important;
    transform: translateX(-50%);
  }

  /deep/ .service_btn {
    position: fixed;
    top: calc(26rem / 16);
    right: calc(20rem / 16);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .icon_lang {
    position: fixed;
    // top: calc(10rem / 16);
    right: calc(20rem / 16);
    height: calc(46rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 9;

    img {
      height: 35px;
      width: 35px;
      object-fit: contain;
      margin-right: 8%;
    }

    span {
      min-width: 55px;
      color: #fff;
      font-size: calc(14rem / 16);
    }
  }

  .deline {
    background: url('../../assets/login/login_logo.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 80px;
    margin: 0 auto;
  }

  .deline1 {
    background: url('../../assets/login/login_header.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 23px;
    margin: 0 auto;
    margin-top: 10px;
  }

  .partners {
    width: calc(100% - 40px);
    padding: 20px 0 10px;
    margin: 0 20px;
    display: flex;

    .partners_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 25%;

      img {
        width: 50px;
        height: 50px;
        display: block;
        object-fit: contain;
      }

      span {
        color: var(--theme);
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .form_wrap_bar {
    width: calc(94% - 36px);
    background: #ffffffe6;
    border-radius: 28px;
    box-shadow: 0 20px 40px rgba(15, 23, 42, .08);
    padding: 18px;
    position: relative;

    .close {
      position: absolute;
      right: 14px;
      z-index: 100;
      top: 14px;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background: #0f172a0f;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 12px;

      span {
        font-size: 20px;
        font-weight: 900;
        color: #0f172a;
      }

      &_img {
        width: 54px;
        height: calc(54rem / 16);
        display: block;
        object-fit: contain;
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .tab_item {
        flex: 1;
        text-align: center;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        padding: 5px;
        color: #6e7a90e6;
        font-weight: 700;
      }

      .active_item {
        color: #18b38d;
        position: relative;

        &::before {
          position: absolute;
          content: '';
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          height: 3px;
          background: #1989fa;
          width: 40px;
        }
      }
    }
  }

  .nav {
    // height: calc(50rem / 16);
    color: var(--textColor);
    display: flex;
    align-items: center;
    margin: calc(26rem / 16) calc(17rem / 16) 0;

    .back {
      transform: rotate(90deg);
    }

    .title {
      font-size: calc(24rem / 16);
      margin-left: calc(14rem / 16);
    }
  }

  .btns {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 10px 16px;
    flex-wrap: wrap;

    .btns_item {
      font-size: 12px;
      color: #2f6ef6;
      font-weight: 700;
    }
  }

  .already_account {
    text-align: center;
    color: var(--light);
    font-size: calc(14rem / 16);
    margin-top: calc(15rem / 16);
    white-space: pre-wrap;

    .register {
      color: var(--yellow);
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
